
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","viewBox":"0 0 34 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.8 6.7H2.3c-.6 0-1 .4-1 1v14.8c0 .6.4 1 1 1h1.9v.2c-.1.5.3 1.1.8 1.2l23.8 4.4h.2c.2 0 .4-.1.6-.2.2-.2.4-.4.4-.6l.9-5h1c.6 0 1-.4 1-1V7.7c-.1-.6-.5-1-1.1-1zm-3.7 20.4L8.4 23.5h20.3l-.6 3.6zm2.7-5.6H3.3V8.7h27.5v12.8z","fill":"#47AEA6"}}),_c('path',{attrs:{"d":"M20.9 11.9L20 11l-2.9 2.9-2.9-2.9-.9.9 2.9 2.9-2.9 2.9.9.9 2.9-2.9 2.9 2.9.9-.9-2.9-2.9 2.9-2.9z","fill":"#F9A91E"}})])
          )
        }
      }
    